import Vue from 'vue';
import VueRouter from 'vue-router';
import { tokenAuthenticator } from '../tokenAuthenticator';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../components/dashboard/DashboardMain.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    // Default path giving 404 error
    path: '*',
    name: 'PageNotFound',
    component: () => import('../views/PageNotFound.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../components/authentication/Login.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/user/register',
    name: 'Register',
    component: () => import('../components/authentication/Register.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/user/passwordreset',
    name: 'PasswordReset',
    component: () => import('../components/authentication/PasswordReset.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/user/changepassword',
    name: 'ChangePassword',
    component: () => import('../components/authentication/ChangePassword.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user/changeemail',
    name: 'ChangeEmail',
    component: () => import('../components/authentication/EmailReset.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/user/edituser',
    name: 'EditUser',
    component: () => import('../components/authentication/ChangeUser.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/releasefiles',
    name: 'ReleaseFiles',
    component: () => import('../components/upgradePackage/ReleaseFileList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/upgradepackagetemplates',
    name: 'UpgradePackageTemplates',
    component: () => import('../components/upgradePackage/UpgradePackageTemplateList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/releasebundles',
    name: 'ReleaseBundles',
    component: () => import('../components/upgradePackage/ReleaseBundleList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/releasebundleeditor/:id',
    name: 'ReleaseBundleEditor',
    component: () => import('../components/upgradePackage/ReleaseBundleEditor.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/targetscoringdefinitions',
    name: 'TargetScoringDefinitions',
    component: () => import('../components/targetScoringDefinition/TargetScoringDefinitionList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/physicaltargetdefinitions',
    name: 'PhysicalTargetDefinitions',
    component: () => import('../components/targetScoringDefinition/PhysicalTargetDefinitionList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/shootingprogramtemplates',
    name: 'ShootingProgramTemplates',
    component: () => import('../components/shootingProgram/ShootingProgramTemplateList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mediafiles',
    name: 'MediaFiles',
    component: () => import('../components/shootingProgram/MediaFiles.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audiofiles',
    name: 'AudioFiles',
    component: () => import('../components/shootingProgram/AudioFiles.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/audiocollections',
    name: 'AudioCollections',
    component: () => import('../components/shootingProgram/AudioCollections.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mediacollections',
    name: 'MediaCollections',
    component: () => import('../components/shootingProgram/MediaCollections.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/addshootingprogramtemplate',
    name: 'AddShootingProgramTemplate',
    component: () => import('../components/shootingProgram/AddShootingProgramTemplate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/editshootingprogramtemplate/:uuid',
    name: 'EditShootingProgramTemplate',
    component: () => import('../components/shootingProgram/EditShootingProgramTemplate.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/organizations',
    name: 'Organizations',
    component: () => import('../components/organization/OrganizationList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/addoreditorganization/:id?',
    name: 'AddOrEditOrganization',
    component: () => import('../components/organization/Edit/AddOrEditOrganization.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/addoreditentitytype/:id?',
    name: 'AddOrEditEntityType',
    component: () => import('../components/organization/Edit/AddOrEditEntityType.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/addoreditclub/:id?',
    name: 'AddOrEditClub',
    component: () => import('../components/organization/Edit/AddOrEditClub.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/clubs',
    name: 'Clubs',
    component: () => import('../components/organization/ClubList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/clubgroups',
    name: 'ClubGroups',
    component: () => import('../components/organization/EntityTypeList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license/production',
    name: 'Production licenses',
    component: () => import('../components/license/ProductionLicenses.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/license/apikeys',
    name: 'API Keys',
    component: () => import('../components/license/ApiKeys.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/ownermanagement',
    name: 'OwnerManagement',
    component: () => import('../components/ownerManagement/OwnerManager.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/arenas',
    name: 'arenas',
    component: () => import('../components/ownerManagement/ArenaList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/unRegisteredEHubs',
    name: 'UnRegisteredEHubs',
    component: () => import('../components/ownerManagement/UnRegisteredEHubsList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../components/usermanagement/UserList.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

// Authenticator timer
setInterval(async () => {
  // Runs at regular interval to keep access token and refresh token up to date

  // Check if needs to update token
  if (tokenAuthenticator.tokenExpired()) {
    if (!(await tokenAuthenticator.updateToken())) {
      // Faild to update token, connection problem or invalid refresh token, redirct to login
      router.push({ name: 'Login' });
    }
  }
}, 60000); // Runs every 60 sec

// Make sure user is authenticated
router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Path requires auth
    let memoryToken = tokenAuthenticator.getToken();
    if (memoryToken) {
      next();
    } else {
      memoryToken = await tokenAuthenticator.updateToken();
      if (memoryToken) {
        next();
      } else {
        tokenAuthenticator.logout();
        next({
          name: 'Login',
        });
      }
    }
  } // Path requires no auth
  else {
    next();
  }
});

export default router;
